// types.ts - New file to hold shared types and enums
export var MenuVariant;
(function (MenuVariant) {
    MenuVariant["DEFAULT"] = "default";
    MenuVariant["SIDE_NAV"] = "sideNav";
    MenuVariant["MODAL_SIDE_NAV"] = "modal_side_nav";
})(MenuVariant || (MenuVariant = {}));
export var MenuTheme;
(function (MenuTheme) {
    MenuTheme["GRAY"] = "gray";
})(MenuTheme || (MenuTheme = {}));
//# sourceMappingURL=types.js.map